import { Component } from '@angular/core';

@Component({
  selector: 'app-plus-icon',
  standalone: true,
  templateUrl: './plus-icon.component.html',
})
export class PlusIconComponent {}
